import React from "react";
import InnerPageLayout from "../../Components/Layout/InnerPageLayout";
import News from "../../Components/news";

interface IProps {
}
const NewsListPage = (props: IProps) => {
  return (
    <InnerPageLayout>
        <News limit={100} />
    </InnerPageLayout>
  );
};
export default NewsListPage;
